<template lang="pug">
.u-margin-top-8x
  h3.p-title.p-title--icon {{$t('shared.risk_objects.generic.house')}}
    Icon(icon="house" classes="p-title__icon")
  Ownership(risk="house" risk_object="habitation")
  Ownership(risk="house" risk_object="theft")
  Ownership(risk="house" risk_object="content")
  Ownership(risk="house" risk_object="assistance_after_fire")
  Ownership(risk="house" risk_object="pj_after_fire")
  Ownership(risk="house" risk_object="mortgage" v-if="shouldInsureMortgage")
  Ownership(risk="house" risk_object="construction" v-if="shouldInsureConstruction")
</template>

<script>
import Icon from '../shared/Icon'
import Ownership from './Ownership'

export default {
  components: {
    Icon,
    Ownership
  },
  computed: {
    shouldInsureMortgage () {
      return this.$store.state.person.has_mortgage
    },
    shouldInsureConstruction () {
      return this.$store.state.person.foreseen_house_work
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  margin-top: 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/insurances/House.vue